<template>
    <section class="survey__row__container__row answer">
        <div class="survey__row__container__row__cell">{{ answer }}</div>
        <slot></slot>
    </section>
</template>

<script>
export default {
    name: 'survey-answer',
    props: {
        answer: String
    }
}
</script>
